import type { ReferralWithdrawal } from '@/api/entities';
import { formatDate } from '@/lib/utils';
import { ArrowDownRight, XCircle } from 'lucide-react';
interface TransactionItemProps {
  transaction: ReferralWithdrawal;
}
export function TransactionItem({
  transaction
}: Readonly<TransactionItemProps>) {
  return <div className="flex items-center justify-between py-4" data-sentry-component="TransactionItem" data-sentry-source-file="transaction-item.tsx">
      <div className="flex items-start gap-3">
        <div className="mt-1">
          {transaction.status === 'Completed' ? <ArrowDownRight className="size-5 text-x-accent-alpha" /> : <XCircle className="size-4 text-red-500" />}
        </div>
        <div>
          <div className="text-lg font-medium">{transaction.amount.toLocaleString()}</div>
          <div className="text-sm text-muted-foreground">{transaction.status}</div>
        </div>
      </div>
      <div className="text-sm text-muted-foreground">{formatDate(transaction.completedAt ?? transaction.requestedAt)}</div>
    </div>;
}